document.addEventListener('product:variant-change', (event) => {
  const product = event.target.closest('.product--avo');
  const variant = event.detail && event.detail.variant;
  if (!product || !variant) return;

  const impact = product.querySelector('[data-avo-impact]');
  const amount = impact && impact.querySelector('[data-avo-impact-amount]');
  if (!impact || !amount) return;

  const percentage = Number(impact.dataset.percentage || 0);
  const currency = window.Shopify && window.Shopify.currency
    ? window.Shopify.currency.active
    : 'USD';

  amount.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency',
    currency
  }).format((variant.price * percentage) / 10000);
});

document.addEventListener('change', (event) => {
  const selector = event.target.closest('[data-avo-size-chart-selector]');
  if (!selector) return;

  const chart = selector.closest('[data-avo-size-chart]');
  if (!chart) return;

  chart.querySelectorAll('[data-avo-size-column]').forEach((cell) => {
    cell.hidden = cell.dataset.avoSizeColumn !== selector.value;
  });
});

const initialiseAvoStickyAtc = (scope = document) => {
  scope.querySelectorAll('.product--avo').forEach((product) => {
    if (product.dataset.avoStickyReady) return;

    const bar = product.querySelector('[data-avo-sticky-atc]');
    const button = bar?.querySelector('[data-avo-sticky-button]');
    const mainButton = product.querySelector('.block-buy-buttons .button-action--primary');
    if (!bar || !button || !mainButton) return;
    product.dataset.avoStickyReady = 'true';

    const buttonPrice = bar.querySelector('[data-avo-sticky-button-price]');
    const action = bar.querySelector('[data-avo-sticky-action]');
    const price = bar.querySelector('[data-avo-sticky-price]');
    const impact = bar.querySelector('[data-avo-sticky-impact]');
    const impactCard = product.querySelector('[data-avo-impact]');
    const currency = window.Shopify?.currency?.active || 'USD';
    const mode = bar.dataset.avoStickyMode;
    const selectsVariant = mode === 'select';
    const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency
    }).format(cents / 100);

    const syncButton = () => {
      if (selectsVariant) {
        button.disabled = false;
        button.classList.add('is-select-size');
        button.setAttribute('aria-label', 'Select size');
        action.textContent = 'SELECT SIZE';
        buttonPrice.hidden = true;
        return;
      }

      const isUnavailable = mainButton.disabled;
      const unavailableLabel = mainButton.textContent.trim();
      button.disabled = isUnavailable;
      button.classList.remove('is-select-size');
      button.setAttribute('aria-label', isUnavailable ? unavailableLabel : 'Add to bag');
      action.textContent = isUnavailable ? unavailableLabel : 'ADD TO BAG · ';
      buttonPrice.hidden = isUnavailable;
    };
    const syncVisibility = () => {
      bar.hidden = mainButton.getBoundingClientRect().bottom >= 0;
    };

    button.addEventListener('click', () => {
      if (selectsVariant) {
        const picker = product.querySelector('.product-block--variant_picker');
        const target = picker || product.querySelector('[data-product-grid-column-details]');
        target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        picker?.querySelector('input:not([disabled]), select:not([disabled])')?.focus({ preventScroll: true });
      } else if (!mainButton.disabled) {
        mainButton.click();
      }
    });

    product.addEventListener('product:variant-change', (event) => {
      const variant = event.detail?.variant;
      if (variant) {
        mainButton.dataset.avoAtcPrice = formatMoney(variant.price);
        price.textContent = formatMoney(variant.price);
        buttonPrice.textContent = formatMoney(variant.price);
        if (impact && impactCard) {
          const percentage = Number(impactCard.dataset.percentage || 0);
          impact.textContent = ` · ${formatMoney(variant.price * percentage / 100)}`;
        }
      }
      requestAnimationFrame(syncButton);
    });
    new MutationObserver(syncButton).observe(mainButton, { attributes: true, attributeFilter: ['disabled'] });
    window.addEventListener('scroll', syncVisibility, { passive: true });
    window.addEventListener('resize', syncVisibility);
    syncButton();
    syncVisibility();
  });
};

document.addEventListener('DOMContentLoaded', () => initialiseAvoStickyAtc());
document.addEventListener('shopify:section:load', (event) => initialiseAvoStickyAtc(event.target));
